<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/household-step1')"></span>
    </div>
    <div class="title">清洁地址详情</div>
    <div class="weui-cells__title">个人信息（重要联系信息，请仔细填写）</div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="请输入联系人名字" v-model="order.data.household_name"/>
            </div>
        </div>
        <div class="weui-cell weui-cells_form">
            <div class="weui-cell__hd">
                <label class="weui-label">手机号</label>
            </div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="tel" placeholder="请输入手机号" v-model="order.data.household_phone" />
            </div>

        </div>

    </div>
    <div class="weui-cells__title">服务地址</div>
    <div class="weui-cells weui-cells_form">
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="如: Unit 2, 9 Hunter St" v-model="order.data.household_street" />
            </div>
        </div>
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">Suburb</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="text" placeholder="如: Chatswood" v-model="order.data.household_suburb" />
            </div>
        </div>
        <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__hd">
                <label for="" class="weui-label">State</label>
            </div>
            <div class="weui-cell__bd">
                <select class="weui-select" name="select2" v-model="order.data.household_state">
                    <option value="NSW" selected>New South Wales</option>
                </select>
            </div>
        </div>
        <div class="weui-cell">
            <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
            <div class="weui-cell__bd">
                <input class="weui-input" type="number" placeholder="如: 2000" v-model="order.data.household_postcode"/>
            </div>
        </div>

        </div>


    <div class="btn-box">
      <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}">下一步</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'addr',
  data () {
    return {
      'order':{},
      'address':{}
    }
  },
  created: function () {
    if (localStorage.order) {
      this.order = JSON.parse(localStorage.order);
      document.querySelector("html").classList.add("grey-background");
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  methods: {
    allFilled(){
        if(this.order.data.household_name && this.order.data.household_phone && this.order.data.household_street && this.order.data.household_suburb && this.order.data.household_state && this.order.data.household_name && this.order.data.household_phone && this.order.data.household_postcode ){
            return true;
        }
    },
    checkSubmit(){
        if(this.allFilled()){
            this.orderUpdateAll('/household-step3');
        }
        else{
            alert('请填写完所有地址信息')
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.navi{
    display: flex;
    justify-content:space-between;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
}

.container{
  background-color: #f8f8f8;
  padding-bottom:60px;
}
.weui-cells__title{
  margin-top:20px;
}
.btn{
	width:300px;
	height: 50px;
	cursor: pointer;
	background: #ddd;
	color:#666;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50px;
	font-size: 1.2em;
    font-weight: 100;
    margin: 0 auto;
    margin-top: 12px;
    max-width:100%;
}

.btn-box{
    background:rgba(255,255,255,1);
    box-shadow: -1px -1px 8px rgba(40,40,40,0.1);
    border-top:1px solid #eee;
    position: fixed;
    bottom: 0px;
    padding-bottom:15px;
    text-align:center;
    width:100%;
    box-sizing:border-box;
    z-index:99;
}
.btn.active{
    color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
    box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.btn:active{
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 50%);
}
.addr-title{
    font-size:0.6em;
    line-height:2em;
    color:#444;
    vertical-align:top;
    display:inline-block;
    text-align:center;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}
</style>



// WEBPACK FOOTER //
// src/pages/household/step2.vue